"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Dropdown", {
    enumerable: true,
    get: function() {
        return Dropdown;
    }
});
var _react = _interop_require_default(require("react"));
var _react1 = require("@chakra-ui/react");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Dropdown = function(props) {
    return _react.default.createElement(_react1.Menu, props);
};
Dropdown.Button = _react1.MenuButton;
Dropdown.List = _react1.MenuList;
Dropdown.Item = _react1.MenuItem;
Dropdown.Group = _react1.MenuGroup;
Dropdown.Divider = _react1.MenuDivider;
Dropdown.OptionGroup = _react1.MenuOptionGroup;
Dropdown.ItemOption = _react1.MenuItemOption;
